<template>
    <Dialog :open="!!token" @update:open="(val) => !val && $emit('close')">
        <DialogContent class="sm:max-w-lg">
            <DialogHeader>
                <DialogTitle>API token created</DialogTitle>
                <DialogDescription>
                    Copy this token now — it won't be shown again. Store it somewhere safe.
                </DialogDescription>
            </DialogHeader>

            <div class="rounded-md bg-new-neutral-50 border border-new-neutral-200 p-3 break-all font-mono text-xs text-foreground">
                {{ token }}
            </div>

            <DialogFooter class="mt-4">
                <Button size="lg" variant="ghost" @click="copyToken">
                    <Copy class="size-4" />
                    {{ copied ? 'Copied' : 'Copy' }}
                </Button>
                <Button size="lg" @click="$emit('close')">Done</Button>
            </DialogFooter>
        </DialogContent>
    </Dialog>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { toast } from 'vue-sonner';
import { Copy } from 'lucide-vue-next';
import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';

const props = defineProps<{
    token: string;
}>();

defineEmits<{
    close: [];
}>();

const copied = ref(false);

const copyToken = async () => {
    try {
        await navigator.clipboard.writeText(props.token);
        copied.value = true;
        toast.success('Token copied to clipboard');
        setTimeout(() => {
            copied.value = false;
        }, 2000);
    } catch {
        toast.error('Failed to copy token');
    }
};
</script>
